document.addEventListener('DOMContentLoaded', function() {
  // Sticky header shadow on scroll
  const header = document.getElementById('header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 10);
    });
  }

  // Mobile menu toggle
  const hamburger = document.getElementById('hamburger');
  const nav = document.getElementById('nav');
  if (hamburger && nav) {
    hamburger.addEventListener('click', function() {
      hamburger.classList.toggle('active');
      nav.classList.toggle('open');
    });

    // Close mobile menu on link click
    nav.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        hamburger.classList.remove('active');
        nav.classList.remove('open');
      });
    });
  }

  // FAQ accordion
  document.querySelectorAll('.faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.parentElement;
      var isActive = item.classList.contains('active');
      document.querySelectorAll('.faq-item').forEach(function(i) {
        i.classList.remove('active');
      });
      if (!isActive) {
        item.classList.add('active');
      }
    });
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var targetSelector = this.getAttribute('href');
      if (targetSelector === '#') return;
      var target = document.querySelector(targetSelector);
      if (target) {
        e.preventDefault();
        var headerEl = document.getElementById('header');
        var offset = headerEl ? headerEl.offsetHeight + 10 : 10;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

  // === How It Works: Video Modal ===
  var videoModal = document.getElementById('videoModal');
  if (videoModal) {
    var modalPlayer = videoModal.querySelector('.video-modal__player');
    var modalSource = modalPlayer.querySelector('source');
    var modalTitle = videoModal.querySelector('.video-modal__title');
    var modalClose = videoModal.querySelector('.video-modal__close');
    var modalBackdrop = videoModal.querySelector('.video-modal__backdrop');
    var modalTrigger = null;

    function openVideoModal(src, title, triggerBtn) {
      modalTrigger = triggerBtn;
      modalSource.setAttribute('src', src);
      modalTitle.textContent = title;
      modalPlayer.load();
      videoModal.classList.add('is-open');
      videoModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      modalPlayer.play().catch(function() {});
      modalClose.focus();
    }

    function closeVideoModal() {
      modalPlayer.pause();
      modalPlayer.currentTime = 0;
      videoModal.classList.remove('is-open');
      videoModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      modalSource.setAttribute('src', '');
      modalPlayer.load();
      if (modalTrigger) {
        modalTrigger.focus();
        modalTrigger = null;
      }
    }

    document.querySelectorAll('.stage-play-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var src = btn.getAttribute('data-video-src');
        var title = btn.getAttribute('data-stage-title');
        openVideoModal(src, title, btn);
      });
    });

    modalClose.addEventListener('click', closeVideoModal);
    modalBackdrop.addEventListener('click', closeVideoModal);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && videoModal.classList.contains('is-open')) {
        closeVideoModal();
      }
    });
  }

  // === How It Works: Lazy Autoplay with Intersection Observer ===
  var loopVideos = document.querySelectorAll('.stage-video-loop');
  if (loopVideos.length > 0) {
    if ('IntersectionObserver' in window) {
      var videoObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.play().catch(function() {});
          } else {
            entry.target.pause();
          }
        });
      }, { threshold: 0.3 });

      loopVideos.forEach(function(video) {
        videoObserver.observe(video);
      });
    } else {
      loopVideos.forEach(function(video) {
        video.setAttribute('autoplay', '');
        video.play().catch(function() {});
      });
    }
  }

  // === How It Works: Mobile Carousel Dots ===
  var stagesGrid = document.querySelector('.stages-grid');
  var carouselDots = document.querySelectorAll('.carousel-dot');
  if (stagesGrid && carouselDots.length > 0) {
    var stageCards = stagesGrid.querySelectorAll('.stage-card');

    stagesGrid.addEventListener('scroll', function() {
      var scrollLeft = stagesGrid.scrollLeft;
      var cardWidth = stageCards[0].offsetWidth + 16;
      var activeIndex = Math.round(scrollLeft / cardWidth);
      carouselDots.forEach(function(dot, i) {
        dot.classList.toggle('active', i === activeIndex);
      });
    });

    carouselDots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var index = parseInt(dot.getAttribute('data-index'));
        var card = stageCards[index];
        if (card) {
          card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    });
  }
});
